import {
  useGetService,
  type UseGetServiceOptions,
} from "@libs/service-providers/api-service-provider";

import { KPI_URL } from "./apiEndpoints";
import type { KpiData } from "./types";

type UseGetKpiOptions = Omit<UseGetServiceOptions<KpiData>, "route" | "queryKey">;

export const useGetKpi = (options?: UseGetKpiOptions) =>
  useGetService<KpiData>({
    route: KPI_URL,
    queryKey: ["dq-dashboard", "kpi"],
    retry: false,
    ...(options ?? {}),
  });
